<template>
  <div class="list_container">
    <div class="datePicker">
      <el-date-picker
        v-model="value"
        class="datePicker" 
        type="daterange"
        range-separator="-"
        start-placeholder="start-time"
        end-placeholder="end-time"
        append-to-body
        value-format="yyyy-MM-dd"
        @change="changeDate"
      />
      <van-search
        v-model="params.id"
        placeholder="Introduza o ID de Membro"
        @blur="searchBlur"
      />
    </div>
    <div class="content_box">
      <template v-if="list.length">
        <div class="list_box">
          <div
            v-for="item in list"
            :key="item.id"
            class="item_box"
          >
            <template v-if="active === 6">
              <div class="tip">
                <div class="text">
                  vip
                </div>
              </div>
              <div class="flex-row">
                <div class="left">
                  <div class="id">
                    {{ item.id }}
                        
                    <div
                      class="icon"
                      @click="onCopy(item.id)"
                    >
                      <i class="el-icon-copy-document copy" />
                    </div>
                  </div>
                  <div class="apo">
                    Apostas Válidas <span>{{ item.total_typing_amount }}</span>
                  </div>
                  <div class="site">
                    ({{ item.betCount }} N.º de boletins de apostas)
                  </div>
                </div>
                <div class="right">
                  Vitórias/Perdas Total <span>{{ item.total_profit }}</span>
                </div>
              </div>
            </template>
            <template v-else-if="active === 5">
              <div class="tip">
                <div class="text">
                  vip
                </div>
              </div>
              <div class="top_info">
                <div class="id">
                  {{ item.id }}
                    
                  <div
                    class="icon"
                    @click="onCopy(item.id)"
                  >
                    <i class="el-icon-copy-document copy" />
                  </div>
                </div>
              </div>
              <div class="bottom_info l5">
                <div>
                  <div>
                    Depósito inicial: <span>{{ item.online }}</span>
                  </div>
                  <div>
                    Atual: <span>{{ item.online }}</span>
                  </div>
                  <div>
                    Estado: <span>{{ item.online }}</span>
                  </div>
                </div>
                <div>
                  <div>
                    Hora de registo <span>{{ item.createtime }}</span>
                  </div>
                  <div>
                    Último início de sessão <span>{{ item.logintime }}</span>
                  </div>
                </div>
              </div>
            </template>
            <template v-else>
              <div class="tip">
                <div class="text">
                  vip
                </div>
              </div>
              <div class="top_info">
                <div class="id">
                  {{ item.id }}
                    
                  <div
                    class="icon"
                    @click="onCopy(item.id)"
                  >
                    <i class="el-icon-copy-document copy" />
                  </div>
                </div>
                <div v-if="active === 2">
                  Apostas Válidas<span>{{ item.total_bet_amount }}</span>
                </div>
                <div v-if="active === 3">
                  Desempenho<span>{{ item.total_bet_amount }}</span>
                </div>
              </div>
              <div class="bottom_info">
                <div>{{ item.createtime }}</div>
                <div v-if="active === 2">
                  Depósito<span>{{ item.total_recharge_amount }}</span>
                </div>
                <div v-if="active === 3">
                  Subordinados<span>{{ item.invite_num }}</span>
                </div>
              </div>
            </template>
          </div>
        </div>
      </template>
      <Empty v-else />
    </div>
  </div>
</template>
<script>
import { Search } from 'vant';
// import Fetch from '../../../utils/fetch';
import Empty from '../../../components/empty.vue';
export default {
    components: {
        VanSearch: Search,
        Empty
    },
    props: {
        list: {
            type: Array,
            default: () => []
        },
        active: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            value: '',
            searchId: '',
            params: {},

            // list: [
            //     {
            //         id: 200001,
            //         time: '04/08/2024 15:00',
            //         ap: '100,88',
            //         dep: '5',
            //         vip: 'v2'
            //     },
            //     {
            //         id: 200002,
            //         time: '04/08/2024 15:00',
            //         ap: '100,88',
            //         dep: '5',
            //         vip: 'v2'
            //     },
            //     {
            //         id: 200003,
            //         time: '04/08/2024 15:00',
            //         ap: '100,88',
            //         dep: '5',
            //         vip: 'v2'
            //     },
            //     {
            //         id: 200004,
            //         time: '04/08/2024 15:00',
            //         ap: '100,88',
            //         dep: '5',
            //         vip: 'v2'
            //     },
            //     {
            //         id: 200005,
            //         time: '04/08/2024 15:00',
            //         ap: '100,88',
            //         dep: '5',
            //         vip: 'v2'
            //     },
            //     {
            //         id: 200006,
            //         time: '04/08/2024 15:00',
            //         ap: '100,88',
            //         dep: '5',
            //         vip: 'v2'
            //     },
            //     {
            //         id: 200007,
            //         time: '04/08/2024 15:00',
            //         ap: '100,88',
            //         dep: '5',
            //         vip: 'v2'
            //     },
            //     {
            //         id: 200008,
            //         time: '04/08/2024 15:00',
            //         ap: '100,88',
            //         dep: '5',
            //         vip: 'v2'
            //     },
            //     {
            //         id: 200009,
            //         time: '04/08/2024 15:00',
            //         ap: '100,88',
            //         dep: '5',
            //         vip: 'v2'
            //     },
            // ],
        }
    },
    methods: {
        
        onCopy() {
            this.$toast({
            message: 'Copy Success',
            duration: 2000,
          });
        },
        onError() {
            this.$toast({
            message: 'Copy error',
            duration: 2000,
          });
        },
        changeDate(e) {
            this.params.startDate = e[0]
            this.params.endDate = e[1]
            this.value = [new Date(e[0]), new Date(e[1])]
            this.$emit('getList', this.params)
        },
        searchBlur() {
            this.$emit('getList', this.params)
        },
        
        doCopy(val) {
            let _this = this;
            this.$copyText(String(val)).then(
                function (e) {
                _this.$toast({
                    background: "#07c160",
                    message: _this.$t("复制成功"),
                });
                },
                function (e) {
                // console.log(e);
                }
            );
        },
    }
}
</script>

<style lang="less" scoped>
@import '../../../assets/css/variables.less';
.list_container {
    position: relative;
}
.flex-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.datePicker {
    display: flex;
    padding: 10px;
    :deep(.el-date-editor) {
        width: 190px;
        background-color: @secondary-color;
        border-color: @bodercolor;
        border-radius: 50px;
        height: 28px;
        .el-range-input {
            height: 20px;
            font-size: 12px;
            color: @textcolorf;
            background-color: transparent;
        }
        .el-range-separator {
            color: @textcolorf;
            height: 28px;
            line-height: 26px;

        }
        .el-input__icon {
            display: none;
        }
    }
    :deep(.van-search) {
        width: 105px;
        padding: 0;
        height: 28px;
        border-radius: 28px;
        background-color: @secondary-color;
        margin-left: 10px;
        .van-search__content {
            border-radius: 28px;
            border: 1px solid @bodercolor;
            background-color: @secondary-color;
        }
        .van-icon {
            color: @textcolorf;
        }
        .van-cell {
            padding: 0 8px 0 0;
            input {
                font-size: 11px;
                color: @textcolorf;
                &::placeholder {
                    font-size: 10px;
                }
            }
        }
    }
}
.content_box {
    padding: 0 12px 12px;
    .list_box {
        min-height: 45vh;
        .item_box {
            position: relative;
            padding: 12px;
            .tip {
                position: absolute;
                left: 0;
                top: 0;
                width: fit-content;
                padding: 0.5px;
                background-color: #c12929;
                border-radius: 2px 2px 0;
                .text {
                    padding: 0 2px;
                    font-size: 6px;
                    font-weight: 700;
                    line-height: 1;
                    -webkit-background-clip: text;
                    background-clip: text;
                    transform: skew(-14deg);
                    -webkit-text-fill-color: transparent;
                    background-image: linear-gradient(180deg, #f7ea94 -5%, #e5b952 58%, #ce9510 114%);
                }
            }
            .top_info {
                margin-bottom: 4px;
            }
            .top_info,
            .bottom_info {
                display: flex;
                font-size: 11px;
                & > div {
                    color: @textcolorf;
                    width: 50%; 
                    span {
                        color: @textcolor4;
                        margin-left: 6px;
                    }
                }
            }
            
            .id {
                display: flex;
                color: @rechargeColor;
                .icon {
                    color: @rechargeColor;
                    margin-left: 6px;
                }
            }
            .l5 {
                margin-top: 8px;
                & > div {
                    width: 66%;
                    font-size: 10px;
                    line-height: 1.2;
                }
                & > div:first-child {
                    width: 34%;
                }
            }
            &:nth-child(2n+1) {
                background-color: @secondary-color;
                border-radius: 4px;
            }
        }
    }
}
.left {
    color: @textcolorf;
    font-size: 11px;
    span {
        color: @rechargeColor;
    }
    .apo {
        margin-top: 8px;
        margin-bottom: 2px;
    }
    .site {
        color: @textcolor1;
    }
}
.right {
    color: @textcolor1;
    padding-right: 20px;
    font-size: 11px;
}
</style>
<style>
.el-date-range-picker {
    width: 8rem;
    left: 20px !important;
}
.el-picker-panel__body {
    position: relative;
    min-width: auto !important;
}
.el-picker-panel__content.is-left {
    width: 100%;
}
.el-picker-panel__content.is-right {
    position: static;
    padding: 0;
}
.el-picker-panel__content.is-right .el-date-range-picker__header {
    position: absolute;
    padding: 0;
    top: 16px;
    right: 16px;
}
.el-picker-panel__content.is-right .el-date-table{
    display: none;
}
.is-right .el-date-range-picker__header div {
    display: none;
}
.popper__arrow {
    left: 50px !important;
}
</style>